/* eslint-disable import/no-unresolved */

import Alert from '@/components/Alert';

import {
  Logout,
  CreateCustomer,
  SplitTable,
  SubmitPayment,
  PrintInvoice,
  ChoosePrinter,
  SavePrinter,
  SaveKOTPrinter,
  AddPayment,
} from '@/components/Modals';

const Modals = () => (
  <>
    <Alert />
    <CreateCustomer />
    <Logout />
    <SplitTable />
    <SubmitPayment />
    <PrintInvoice />
    <ChoosePrinter />
    <SavePrinter />
    <SaveKOTPrinter />
    <AddPayment />
  </>
);

export default Modals;
